<template>   
      <b-card no-body>
        <b-card-header>
          <h3 tabindex="0">Duplicar Formulário</h3>
        </b-card-header>  
        <b-card-body>
          <b-form v-on:submit.prevent="onSubmit">          
            <b-row>              
                <b-col sm="8">
                    <b-form-group label="Selecione o Grupo no qual será vinculado o formulário:">
                        <b-form-select v-model="grupoId" :state="chkState('grupo')" placeholder="Situação" class="mb-3">
                              <option selected :value="null">Selecione</option>
                              <option v-for="grupo in grupos" :key="grupo.id" :value="grupo.id"> {{grupo.nome}}</option>
                        </b-form-select>
                        <b-form-invalid-feedback id="input1LiveFeedback3">Grupo é obrigatório.</b-form-invalid-feedback>
                    </b-form-group>                    
                </b-col>
             </b-row>
          </b-form>
        </b-card-body>
        <b-card-footer class="p-12">
          <b-row>
            <b-col v-if="!loading" md="3">
              <b-button block variant="primary" :disabled="disable_buttons" v-on:click="onSubmit">
                <i class="fa fa-plus"></i>&nbsp;
                <span>Salvar</span>
              </b-button>
            </b-col>
            <b-col v-if="loading" md="3">
              <b-button block variant="primary" :disabled="false" v-on:click="onSubmit">
                <b-spinner small type="grow"></b-spinner>Enviando...
              </b-button>
            </b-col>
            <b-col md="3">
              <b-button block variant="secondary" :disabled="disable_buttons" @click="mensagemVoltar()">
                <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-card>
</template>


<script>
import Vue from 'vue'
import VueSelect from 'vue-select'
import Multiselect from 'vue-multiselect'
import {validationMixin} from 'vuelidate'
import {required, minLength, maxLength, email, sameAs, requiredIf} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'

Vue.component('multiselect', Multiselect)

miniToastr.init()

export default {
  name: 'GrupoCadastrar',
  components: {
    VueSelect,
    Multiselect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      nome: {
        required
      },
      situacao: {
        required
      },

    }
  },
  created () {
    this.buscarGrupos()
    if (!this.validaPerfil()) {
      this.$router.push('/')
    }
  },
  data () {
    return {
      loading: false,
      grupoId: null,
      grupos: [],
      options: [
        { text: 'Ativo', value: true },
        { text: 'Inativo', value: false }
      ],
      usuarioId: SessionStorage.get('usuario'),
      disable_buttons: false,
      salvarForm: false 
    }
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    },
  },
  watch: {
  },
  methods: {
    buscarGrupos(){      
      Vue.http.get('api/usuario/' + this.usuarioId).then(response => {    
        this.perfil = response.data.data[0].perfil
         if(this.perfil == 'Gestor'){
            Vue.http.get('api/grupo/buscarGruposUsuarios/' + this.usuarioId).then(response => {
              this.grupos = response.body.data
            })
          }else{
            Vue.http.get('api/grupo?user_id='+this.usuarioId).then(response => {
              this.grupos = response.body.data.data
            })
          } 
      })      
    },
    salvar () {
      let data = {
        id: this.grupoId,
        id_formulario: this.$route.params.id
      }

      Vue.http.post('api/formulario/duplicar', data).then(response => {
            if (response.body.success) {
              console.log(response.body.data[0])
              window.location.href = response.body.data[0]
            }
        }).catch(erro => {
            if (!erro.body.success) {
            miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
            miniToastr.error(erro.body.msg, 'Alerta!', 7000)
           
            }
        })
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar o cadastro do formulário?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {         
           this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    mensagemVoltar() {
      if(this.grupoId !== null){
        this.$bvModal.msgBoxConfirm('Tem certeza que deseja voltar? As informações inseridas serão perdidas.', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        }).then(valor => {
          if (valor) {         
            this.$router.push({path: '/formularios'})    
          }
        }).catch(erro => {
          console.log(erro)
        })
      }else{
        this.$router.push({path: '/formularios'})  
      } 
    },
    onSubmit () {
      this.salvarForm = true
      if (this.validate()) {
        this.confirmar()
      }
    },
    validate () {
       let result = true

      if (!this.grupoId) {
        result = false
      }

      return result
    },
    chkState (val) {
       switch (val) {
        case 'grupo':
          return !!this.grupoId
       default:
          return false
      }
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    navigate (route) {
      this.$router.push(route)
    },
    validaPerfil () {
      let perfil = this.$store.state.perfil.perfil     
      if (perfil.is_admin_conferencia) {
        return true
      }
      return false
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/pages/site/interna/formularios/FormularioDuplicar.vue